package components.accounting

import it.neckar.react.common.router.*
import react.*
import react.dom.*
import react.router.*
import router.PathConstants
import router.useDocumentTitle
import store.hooks.useRequireCompanyForLoggedInUser

val AccountingOverviews: FC<Props> = fc("AccountingOverviews") {
  val companyName = useRequireCompanyForLoggedInUser().simpleName

  useDocumentTitle(companyName, "Abrechnung")

  div("mt-5") {
    tabButtonsPane {

      tabButton(NavigateUrl.empty, "Übersicht")

      tabButton(NavigateUrl(PathConstants.editAccounting), "Abrechnung")

      tabButton(NavigateUrl(PathConstants.invoices), "Rechungen")

    }
  }

  div("mt-5") {
    Outlet {}
  }
}
